import Devextreme from "@sonphat/devextreme";
export default function Helper($Core, emitter) {
    Devextreme.$Core = $Core;

    this.getTextLoaiLich = (data, i18n, helper) => {
        if (data.loaiLichChay == i18n.t("DBVarName.Tuan")) {
            let dsNgayText = data.cacNgayChayTheoLich.map((e) => {
                if (e == 1) {
                    return "Chủ nhật";
                } else {
                    return "Thứ " + e;
                }
            });
            return "Lịch tuần" + " - " + dsNgayText.join(", ");
        } else if (data.loaiLichChay == i18n.t("DBVarName.ThangDuong")) {
            return "Lịch dương " + " - " + data.cacNgayChayTheoLich.join(", ");
        } else if (data.loaiLichChay == i18n.t("DBVarName.ThangAm")) {
            return "Lịch âm " + " - " + data.cacNgayChayTheoLich.join(", ");
        } else if (data.loaiLichChay == i18n.t("DBVarName.ChuKy")) {
            return (
                "Từ ngày " +
                helper.formatDate(data.ngayBatDauChuKy) +
                ", cách " +
                data.chuKyNgay +
                " ngày chạy 1 chuyến!"
            );
        }
    };

    this.ThongBaoToast = (type, msg) => {
        let ParamsError = {
            isVisible: true,
            message: msg,
            type: type,
        };
        emitter.emit("onToast", ParamsError);
    };

    this.ThongBaoPopup = ({
        type,
        message_title,
        message,
        title,
        textButton,
        widthPopup,
    }) => {
        let ParamsError = {
            type: type || "Error",
            title: title || "Thông báo",
            message_title: message_title || "Lỗi!",
            message: message || "",
            textButton: textButton || "Đồng ý",
            widthPopup: widthPopup || 424,
        };
        emitter.emit("ThongBaoPopup", ParamsError);
    };

    this.checkPath = (url) => {
        let u = new URL(url);
        let arr = u.pathname.split("//");
        u.pathname = arr.join("/");
        return "" + u;
    };

    this.Common = Devextreme;

    // Danh sách hàm trong thư viện
    // FilterRowWhenEnter
    // DevExDataSource
    // DevExDataSourceCustom
    // formatDateTime
    // formatDate
    // formatTime
    // getToday
    // getEndDateString
    // getEndDay
    // getStartDay
    // getTimeString
    // getEndMonth
    // getStartMonth
    // formatDateToTimeZone7
    // formatViewDateToTimeZone7
    // CheckRole
    // table
    // excel
    // randomGUID
    // formatPhone
    // moneyFormat
}
